
<template>
    <div>
        <formdialog 
            :form="form" 
            :shadow="true"
            v-if="startRegistration"
            :dialog="startRegistration" 
            v-on:submitForm="registerDevice($event)"
            v-on:rejectForm="$emit('abort')"
            v-on:routing="browse($event)"
        ></formdialog>


        <v-dialog v-model="startDownload" persistent max-width="420">
            <v-card>
                <v-card-title style="color:#1565c0"  class="headline">Device credentials</v-card-title>
                <v-card-text> 
                <v-container fluid style="margin-top:-20px">
                    <v-layout row wrap >
                    <v-flex xs12 sm12 md12>
                        <v-btn dark class="blue darken-2" v-on:click="downloadCredentials()"><v-icon color="amber" style="margin-right:3px">attachment</v-icon> Download</v-btn>
                    </v-flex>
                    </v-layout>
                    <v-layout row wrap >
                    <v-flex xs12 sm12 md12>
                        <v-checkbox
                            v-model="downloaded"
                            color="success"
                            value="success"
                            hide-details
                        >
                            <template v-slot:label>
                            <span class="body-1" style="margin-top:5px">I confirm that I have downloaded file containing device credentials</span>
                            </template>                  
                        </v-checkbox>
                    </v-flex>
                    </v-layout>
                </v-container>
                </v-card-text>
                <v-card-actions style="margin-top:-2em">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-2" :disabled="!downloaded" flat @click="startDownload=false;$emit('completed')">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>  
    import { mapState } from 'vuex'
    import {FormPayload,Validator,FormStructField} from '@/components/models/FormDialog'
    
    export default {
        name: "RegisterDevice",

        props:{
            gateway: String,

            values:Object
        },

        data: function(){
            return {
                startRegistration : false,
                startDownload : false,
                dataToDownload : null,
                downloaded: false
            }
        },
        
        computed: {
            ...mapState(
                {
                    deviceModel: state => state.metadata.models.data.newDevice,
                    childDeviceModel: state => state.metadata.models.data.newChildDevice
                }
            ),

            model: function(){ 
                return (this.gateway)?this.childDeviceModel:this.deviceModel
            }
        },

        mounted: function(){
            this.startRegistration = true
            this.buildForm()
        },

        methods: {
            registerDevice(deviceModel){
                this.startRegistration=false

                deviceModel.gateway = this.gateway
                
                this.$store.dispatch('devices/registerDevice',deviceModel)
                .then((data)=>{
                    this.$store.dispatch('devices/fetchDevices').then(()=>{}).catch(()=>{})
                    if(data.isAvailable==true){
                        this.startDownload = true
                        this.dataToDownload = data
                    }else{
                        this.$emit("completed")
                    }
                })
                .catch((err)=>{
                    this.$emit("abort",true)
                    throw err
                })
            },

            buildForm(){

                this.form = new FormPayload({
                    title: this.model.title,
                    icon: this.model.icon,
                    block: false,
                })
                for(let index in this.model.fields){
                    let fieldModel = this.model.fields[index]
                    let field =  new FormStructField({
                        name: fieldModel.name,
                        label: fieldModel.label,
                        type: fieldModel.type,
                        icon: fieldModel.icon,
                        show: fieldModel.show,
                        select: (!fieldModel.values)?((this.values)?this.values[fieldModel.name]:fieldModel.values):fieldModel.values,
                        default: fieldModel.default,
                        hint : fieldModel.hint,
                        disableIfDefined: fieldModel.disableIfDefined,
                        if:fieldModel.if,
                        randgen: fieldModel.randgen
                    })
                    console.log(fieldModel.name)
                    console.log(fieldModel.required)
                    let validator = new Validator({
                        regex: fieldModel.regexp,
                        required: fieldModel.required,
                        min: fieldModel.min,
                        max: fieldModel.max
                    })
                    field.setValidator(validator)
                    this.form.addField(field)
                }
            },

            downloadCredentials(){
                let saveData = function (data, fileName) {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var 
                        blob = new Blob(data.split(), {type: "octet/stream"}),
                        url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        a.click();
                        window.URL.revokeObjectURL(url);
                }

                try{
                    saveData(this.dataToDownload.credentials,this.dataToDownload.name+".pem")
                    let fileData = [this.dataToDownload.credentials]
                    window.navigator.msSaveOrOpenBlob(new Blob(fileData),this.dataToDownload.name+".pem")
                }catch(ex){
                    saveData = null
                }
            },
            async browse(view){
                //this.$router.push(view)
                await this.$store.commit('browseApp',view) 
            }
        }
    }
</script>